/* eslint-disable */
import axios from 'axios';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const authLogin = (data) => axiosInstance.post('/auth', { ...data, ...pickDevParams });
export const authConfiguration = () => axiosInstance.get('/auth/configuration', { params: { ...pickDevParams } });
export const authConfirm = (data) => axiosInstance.post('/auth/confirm', { ...data, ...pickDevParams });
export const authReject = (data) => axiosInstance.post('/auth/reject', { ...data, ...pickDevParams });
export const authConfirmApp = (data) => axiosInstance.post('/auth/confirm-app', { ...data, ...pickDevParams });
export const authCheck = (data) => axiosInstance.get('/auth/check', { ...data, ...pickDevParams });
export const authUpdate2faCode = (data) => axiosInstance.post('/auth/update-two-fa-code', { ...data, ...pickDevParams });
export const authLogout = (data) => axiosInstance.post('/auth/logout', { ...data, ...pickDevParams });

/* Without axios instance */
export const authSuperAdmin = (data) =>
  axios.post(
    '/admin/api/auth/super',
    { ...data },
    {
      withCredentials: true,
    },
  );
export const authRefresh = (cancelToken) =>
  axios.post(
    '/admin/api/auth/refresh',
    {},
    {
      withCredentials: true,
      cancelToken,
    },
  );
